import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

import { ROUTES, insertIdtoUrl } from "constants/Routes.js";
import BusinessUserInvitationApi from "apis/BusinessUserInvitation";
import BusinessUserInvitationForm from "./BusinessUserInvitationForm";
import Loading from "utils/Loading";

class AddNewBusinessUserInvitation extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      role: "",
      loading: false,
      redirect: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.addUserInvitation = this.addUserInvitation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  addUserInvitation() {
    this.setState({ loading: true });
    const { email } = this.state;
    let { role } = this.state;
    if (role === "" || role === "admin") {
      role = 0;
    } else {
      role = 1;
    }
    BusinessUserInvitationApi.addNew(email, role, this.props.businessId)
      .then(data => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Invitation link sent to {email}.
          </div>
        ));
        setTimeout(() => {
          this.setState({ loading: false, redirect: true })
      }, 2000);

      })
      .catch(e => {
        this.setState({ loading: false });
        toast.error(() => (
          <div>
            <FontAwesomeIcon icon="times-circle" />
            {e.response.data.error}
          </div>
        ));
        console.log(e);
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.addUserInvitation();
  }

  handleChange(e) {
    let _state = {};
    _state[e.target.name] = e.target.value;
    this.setState(_state);
  }
  render() {
    if (this.state.loading === true) {
      return <div><Loading /></div>;
    } else if (this.state.redirect === true) {
      return (
        <Redirect
          to={{
            pathname: insertIdtoUrl(ROUTES.USERS_LIST, this.props.businessId),
            userInvited: true
          }}
        />
      );
    } else {
      return (
        <div>
          <BusinessUserInvitationForm
            user={this.state}
            handleChange={this.handleChange}
            create={true}
            businessId={this.props.businessId}
            addUserInvitation={this.props.addUserInvitation}
            handleSubmit={this.handleSubmit}
          />
        </div>
      );
    }
  }
}

export default AddNewBusinessUserInvitation;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/invitation/AddNewBusinessUserInvitation.js